"use client";

import React from "react";
import { CalendarCheck, ClipboardCheck, Key, Armchair, Users } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "RDV visites cloisons, OPL & Livraisons",
  description: "Gestion complète du rdv : accueil, visite et état des lieux du logement, saisie des réserves sur appli dédiée, partie administrative et financière, remise de clés.",
  icon: CalendarCheck
}, {
  title: "Suivi levée réserves",
  description: "Gestion technique et rigoureuse de la levée des réserves de livraisons et GPA jusqu'à leur levée totale pour garantir le bon achèvement de l'opération.",
  icon: ClipboardCheck
}, {
  title: "Conciergerie",
  description: "Post livraisons, services dédiés pour faciliter l'installation des occupants et assurer une expérience client premium.",
  icon: Key
}, {
  title: "Pack mobilier",
  description: "Solutions d'ameublement selon 3 formules pour équiper votre logement d'accueil lors des livraisons (buffet, bureaux, mobilier pièce de vie)",
  icon: Armchair
}, {
  title: "Relation acquéreurs",
  description: "Prise en main (ponctuelle ou complète) de la relation clients notamment lors des TMA, fiches de choix...",
  icon: Users
}];
export default function Prestations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="prestations" ref={ref} className="bg-background overflow-hidden ![padding:60px_0px_60px_0px]">
      <div className="container mx-auto px-4">
        <div className={`transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-16 tracking-tight" style={{
          fontFamily: 'Space Grotesk, sans-serif'
        }}>Nos prestations AMO Livraisons</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {services.map((service, i) => <div key={i} data-index={i} className={`h-full transition-all duration-700 ease-out delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <Card className="h-full border border-secondary/40 shadow-sm hover:shadow-md transition-shadow duration-300 rounded-xl bg-card/50 backdrop-blur-sm">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-secondary/10 text-primary">
                      <service.icon className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-lg font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}